import React from 'react';
import { Formik } from 'formik';
import { Form as SForm } from 'semantic-ui-react';
import { EmploymentSearchDto } from '@app/api2/api';
import { SEARCH_TYPES_NAMES } from '../../types';
import { EmploymentSearchSchema } from './EmploymentForm.Schema';
import SemanticFormikInput from '@app/components/React/Common/Forms/SemanticFormikInput';
import { FormWithButtons } from './FormWithButtons';
import { ChangeObserver } from '@app/components/React/Labs/ChangeObserver';

interface Props {
  currentParams: EmploymentSearchDto;
  setCurrentParams: (p: EmploymentSearchDto) => void;
  onChange?: (params: EmploymentSearchDto) => void;
}

export default function EmploymentForm({ currentParams, setCurrentParams, onChange }: Props) {
  const discriminator = SEARCH_TYPES_NAMES.EmploymentSearchDto;

  const initialValues: EmploymentSearchDto = {
    discriminator,
    operator: currentParams.operator,
    occupation: currentParams.occupation || '',
    employerName: currentParams.employerName || '',
    employerCity: currentParams.employerCity || '',
  };

  const handleSubmit = (values: EmploymentSearchDto) => {
    setCurrentParams({ ...values, discriminator });
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={EmploymentSearchSchema}
      onSubmit={handleSubmit}
      validateOnBlur={false}
      validateOnChange={false}
      enableReinitialize
    >
      {({ handleSubmit, values }) => (
        <>
          <ChangeObserver value={values} onChange={onChange} />

          <FormWithButtons handleSubmit={handleSubmit}>
            <SForm.Group widths="equal">
              <SemanticFormikInput
                name="occupation"
                label="Occupation"
                placeholder="Enter occupation"
              />
              <SemanticFormikInput
                name="employerName"
                label="Employer Name"
                placeholder="Enter employer"
              />
              <SemanticFormikInput
                name="employerCity"
                label="Employer City"
                placeholder="Enter city"
              />
            </SForm.Group>
          </FormWithButtons>
        </>
      )}
    </Formik>
  );
}
